export default __webpack_public_path__ + "static/media/switch-off.e5ebe933.mp3";